import React, { useEffect } from 'react'
import withRouter from 'react-router-dom/withRouter'
import { useCookieYes } from '../../../../providers/CookiesProvider'

const GAINSIGHT_API_KEY = globalThis.gainsightCode

const GainsightCmp = props => {
  const firmId = props.match.params?.firmId
  const { consentGiven, preferences } = useCookieYes()

  // Load Gainsight script when consent is given
  useEffect(() => {
    if (consentGiven && preferences.analytics) {
      console.log('loading gainsight')
      loadGainsightScript()
    }
  }, [consentGiven, preferences])

  // Initialize user identification when firmId is available and script is loaded
  useEffect(() => {
    if (firmId && window.aptrinsic && consentGiven && preferences.analytics) {
      initGainsightFlow()
    }
  }, [firmId, consentGiven, preferences])

  const loadGainsightScript = () => {
    if (window.aptrinsic) {
      console.log('Gainsight PX already loaded')
      return
    }

    ;(function (n, t, a, e) {
      var i = 'aptrinsic'
      ;(n[i] =
        n[i] ||
        function () {
          ;(n[i].q = n[i].q || []).push(arguments)
        }),
        (n[i].p = e)
      var r = t.createElement('script')
      ;(r.async = !0), (r.src = a + '?a=' + e)
      var c = t.getElementsByTagName('script')[0]
      c.parentNode.insertBefore(r, c)
    })(
      window,
      document,
      'https://web-sdk.aptrinsic.com/api/aptrinsic.js',
      GAINSIGHT_API_KEY,
    )

    console.log('Gainsight PX loaded')
  }

  const initGainsightFlow = async () => {
    try {
      const gainsightData = await retrieveGainsightData(firmId)
      if (!gainsightData) {
        return
      }
      if (gainsightData.staff && gainsightData.success) {
        sendDataToGainsight(gainsightData.staff)
      }
    } catch (error) {
      console.error('Error in Gainsight flow:', error)
    }
  }

  const retrieveGainsightData = async firmId => {
    try {
      const response = await fetch(`/api/salesforce/${parseInt(firmId)}`, {
        method: 'POST',
      })
      return await response.json()
    } catch (error) {
      console.error('Error fetching data:', error)
      return null
    }
  }

  const sendDataToGainsight = staff => {
    if (!window.aptrinsic) {
      return console.warn('Aptrinsic not loaded')
    }

    if (!consentGiven || !preferences.analytics) {
      return console.warn('No analytics consent - data not sent to Gainsight')
    }

    window.aptrinsic(
      'identify',
      {
        id: `mangoshare-staff-${staff._id}`,
        email: `${staff.user.username}`,
        firstName: `${staff.user.firstname}`,
        lastName: `${staff.user.lastname}`,
      },
      {
        id: `mangoshare-firm-${staff.firm._id}`,
        name: `${staff?.firm.name}`,
      },
    )
  }

  return null
}
export default withRouter(GainsightCmp)
